import React from 'react';

export const MANATAL_LOGO_URL = '/integration-logos/manatal.png';

interface ManatalBadgeProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Badge component to indicate a job was sourced from Manatal ATS.
 * Displays the Manatal logo with subtle styling.
 */
export const ManatalBadge: React.FC<ManatalBadgeProps> = ({
  className = '',
  size = 'sm',
}) => {
  const sizeClasses = {
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <div
      className={`inline-flex items-center gap-1 ${className}`}
      title="Sourced from Manatal"
    >
      <img
        src={MANATAL_LOGO_URL}
        alt="Manatal"
        className={`${sizeClasses[size]} rounded-md object-cover opacity-70 hover:opacity-100 transition-opacity`}
      />
    </div>
  );
};

export default ManatalBadge;
